// extracted by mini-css-extract-plugin
export var border = "CharacterSpacer-module--border--jhUNd";
export var character = "CharacterSpacer-module--character--Ru5z0";
export var cyan = "CharacterSpacer-module--cyan--B1Hoi";
export var left = "CharacterSpacer-module--left--w7889";
export var pink = "CharacterSpacer-module--pink--ki4Mr";
export var purple = "CharacterSpacer-module--purple--qqkom";
export var red = "CharacterSpacer-module--red--PFAXx";
export var root = "CharacterSpacer-module--root--lMmKH";
export var x1 = "CharacterSpacer-module--x1--WWaQC";
export var x2 = "CharacterSpacer-module--x2--9q63B";
export var x3 = "CharacterSpacer-module--x3--5ya-j";
export var x4 = "CharacterSpacer-module--x4--MYOoj";